var map = {
	"../arianee-brands-list/arianee-brands-list.module": [
		"./src/app/pages/main/arianee-brands-list/arianee-brands-list.module.ts",
		"arianee-brands-list-arianee-brands-list-module"
	],
	"../brand-list/brand-list.module": [
		"./src/app/pages/main/brand-list/brand-list.module.ts",
		"brand-list-brand-list-module"
	],
	"../brand-page/brand-page.module": [
		"./src/app/pages/main/brand-page/brand-page.module.ts",
		"brand-page-brand-page-module"
	],
	"../brand-product-list/brand-product-list.module": [
		"./src/app/pages/main/brand-product-list/brand-product-list.module.ts",
		"brand-product-list-brand-product-list-module"
	],
	"../certificate-card/certificate-card.module": [
		"./src/app/pages/main/certificate-card/certificate-card.module.ts",
		"certificate-card-certificate-card-module"
	],
	"../chat/chat.module": [
		"./src/app/pages/main/chat/chat.module.ts",
		"chat-chat-module"
	],
	"../exchange/exchange.module": [
		"./src/app/pages/main/exchange/exchange.module.ts",
		"exchange-exchange-module"
	],
	"../noti/noti.module": [
		"./src/app/pages/main/noti/noti.module.ts",
		"noti-noti-module"
	],
	"../poap-detail/poap-detail.module": [
		"./src/app/pages/main/poap-detail/poap-detail.module.ts",
		"poap-detail-poap-detail-module"
	],
	"../poap-nft-list/poap-nft-list.module": [
		"./src/app/pages/main/poap-nft-list/poap-nft-list.module.ts",
		"poap-nft-list-poap-nft-list-module"
	],
	"../product-detail/product-detail.module": [
		"./src/app/pages/main/product-detail/product-detail.module.ts",
		"product-detail-product-detail-module"
	],
	"../scan-edgyn/scan-edgyn.module": [
		"./src/app/pages/main/scan-edgyn/scan-edgyn.module.ts",
		"scan-edgyn-scan-edgyn-module"
	],
	"../scan-v2/scan-v2.module": [
		"./src/app/pages/main/scan-v2/scan-v2.module.ts",
		"common",
		"scan-v2-scan-v2-module"
	],
	"../scan/scan.module": [
		"./src/app/pages/main/scan/scan.module.ts",
		"scan-scan-module"
	],
	"../setting/setting.module": [
		"./src/app/pages/main/setting/setting.module.ts",
		"setting-setting-module"
	],
	"./pages/auth/auth.module": [
		"./src/app/pages/auth/auth.module.ts"
	],
	"./pages/demo/demo.module": [
		"./src/app/pages/demo/demo.module.ts",
		"pages-demo-demo-module"
	],
	"./pages/digit-print/digit-print.module": [
		"./src/app/pages/digit-print/digit-print.module.ts",
		"pages-digit-print-digit-print-module"
	],
	"./pages/face-id/face-id.module": [
		"./src/app/pages/face-id/face-id.module.ts",
		"pages-face-id-face-id-module"
	],
	"./pages/import-custodial-mnemonic/import-custodial-mnemonic.module": [
		"./src/app/pages/import-custodial-mnemonic/import-custodial-mnemonic.module.ts",
		"common",
		"pages-import-custodial-mnemonic-import-custodial-mnemonic-module"
	],
	"./pages/import-encrypted-mnemonic/import-encrypted-mnemonic.module": [
		"./src/app/pages/import-encrypted-mnemonic/import-encrypted-mnemonic.module.ts",
		"pages-import-encrypted-mnemonic-import-encrypted-mnemonic-module"
	],
	"./pages/intro/intro.module": [
		"./src/app/pages/intro/intro.module.ts"
	],
	"./pages/main/backup-import-success/backup-import-success.module": [
		"./src/app/pages/main/backup-import-success/backup-import-success.module.ts",
		"pages-main-backup-import-success-backup-import-success-module"
	],
	"./pages/main/backup-import/backup-import.module": [
		"./src/app/pages/main/backup-import/backup-import.module.ts",
		"pages-main-backup-import-backup-import-module"
	],
	"./pages/main/backup-manually-success/backup-manually-success.module": [
		"./src/app/pages/main/backup-manually-success/backup-manually-success.module.ts",
		"pages-main-backup-manually-success-backup-manually-success-module"
	],
	"./pages/main/backup-viewer/backup-viewer.module": [
		"./src/app/pages/main/backup-viewer/backup-viewer.module.ts",
		"pages-main-backup-viewer-backup-viewer-module"
	],
	"./pages/main/backup-viewer1/backup-viewer1.module": [
		"./src/app/pages/main/backup-viewer1/backup-viewer1.module.ts",
		"pages-main-backup-viewer1-backup-viewer1-module"
	],
	"./pages/main/backup-viewer2/backup-viewer2.module": [
		"./src/app/pages/main/backup-viewer2/backup-viewer2.module.ts",
		"pages-main-backup-viewer2-backup-viewer2-module"
	],
	"./pages/main/brand-page/brand-page.module": [
		"./src/app/pages/main/brand-page/brand-page.module.ts",
		"brand-page-brand-page-module"
	],
	"./pages/main/chat/chat.module": [
		"./src/app/pages/main/chat/chat.module.ts",
		"chat-chat-module"
	],
	"./pages/main/cloud-import/cloud-import.module": [
		"./src/app/pages/main/cloud-import/cloud-import.module.ts",
		"pages-main-cloud-import-cloud-import-module"
	],
	"./pages/main/export-mnemonic/export-mnemonic.module": [
		"./src/app/pages/main/export-mnemonic/export-mnemonic.module.ts",
		"common",
		"pages-main-export-mnemonic-export-mnemonic-module"
	],
	"./pages/main/faq/faq.module": [
		"./src/app/pages/main/faq/faq.module.ts",
		"pages-main-faq-faq-module"
	],
	"./pages/main/home-backup/home-backup.module": [
		"./src/app/pages/main/home-backup/home-backup.module.ts",
		"pages-main-home-backup-home-backup-module"
	],
	"./pages/main/home-import/home-import.module": [
		"./src/app/pages/main/home-import/home-import.module.ts",
		"pages-main-home-import-home-import-module"
	],
	"./pages/main/product-detail/product-detail.module": [
		"./src/app/pages/main/product-detail/product-detail.module.ts",
		"product-detail-product-detail-module"
	],
	"./pages/main/setting/setting.module": [
		"./src/app/pages/main/setting/setting.module.ts",
		"setting-setting-module"
	],
	"./pages/main/share-photo/share-photo.module": [
		"./src/app/pages/main/share-photo/share-photo.module.ts",
		"pages-main-share-photo-share-photo-module"
	],
	"./pages/main/tab/tab.module": [
		"./src/app/pages/main/tab/tab.module.ts",
		"common",
		"pages-main-tab-tab-module"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 7);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;